import React from 'react';
import {Box, Typography} from '@mui/material';
import RecommendPlanForm, {
  RecommendPlanFormsStyled,
} from '../CreateRecommend/RecommendSourceDestination/RecommendPlanForm';
import {recommendFieldsType, mainPlanTypeType} from '../CreateRecommend/recommendFields';
import type {contributeDestinationValuesType} from './contributeFields';
import {Pot} from '../../../schema-types/Pot';
import {getSavedChildSubPlans} from '../RecommendsSetUpNew/ListNewSubPlans';
import {ContributeSubplanDestinationAmounts} from '../CreateRecommend/RecommendSourceDestination/ContributeSubplanDestinationAmounts';
import {getCurrencyString} from '../../../utils/currencyFormatter';
import {useAutoForm, useAutoField} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';
import {ComboFrequencyEnum} from '../../../schema-types/globalTypes';

export const ContributeExistingSubplans: React.FC<{
  parentId: string;
  pots: Pot[];
  showEditing?: boolean;
  // disableSecondSubplan?: boolean;
  mainPlanType: mainPlanTypeType;
  comboFrequency: ComboFrequencyEnum | undefined;
}> = ({
  parentId,
  pots,
  // disableSecondSubplan,
  showEditing,
  mainPlanType,
  comboFrequency,
}) => {
  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();
  const subPlanSavedValues = getSavedChildSubPlans(pots!, parentId);
  const [destinationValuesObj] = useAutoField<contributeDestinationValuesType>(
    `contribute.destinationValues`
  );

  const sortedSubPlans = [...subPlanSavedValues].sort((a, b) => {
    if (a.isSaltus) {
      return -1;
    }
    if (b.isSaltus) {
      return 1;
    }
    return 0;
  });
  const checkedList = Object.entries(destinationValuesObj.value?.subplans || {}).filter(
    ([id, fields]) => fields.checked
  );

  return (
    <Box ml={2}>
      <RecommendPlanFormsStyled>
        {sortedSubPlans.map((subPlan, index) => (
          <RecommendPlanForm
            key={subPlan.id}
            id={subPlan.id}
            mode="multiple"
            reccId={subPlan.originalOvrId}
            summary={
              <Typography>{`Subplan ${
                subPlan.name ||
                `${subPlan.productProvider?.formattedName} ${
                  subPlan.productName?.formattedName
                } ${getCurrencyString(subPlan.totalValue)}`
              }`}</Typography>
            }
            details={
              <ContributeSubplanDestinationAmounts
                formikKeyPrefix={`contribute.destinationValues.subplans.${subPlan.id}`}
                disabled={(!index && subPlanSavedValues.length > 1) || !showEditing}
                potInner={subPlan}
                mainPlanType={mainPlanType}
                comboFrequency={comboFrequency}
              />
            }
            isSelected={checkedList.map(([id]) => id).includes(subPlan.id) || false}
            isSubplan
            handleChange={(id) => {
              setFieldValue(
                UPDATES._519,
                `contribute.destinationValues.subplans.${id}.checked`,
                !destinationValuesObj.value?.subplans?.[id]?.checked
              );
            }}
          />
        ))}
      </RecommendPlanFormsStyled>
    </Box>
  );
};
